
export default {
  props: ["title", "route2", "title2"],
};
